import DT from 'duration-time-conversion';
import axios from 'axios';
import api from 'services/api';

import { toast } from 'react-toastify';

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    window.navigator.userAgent,
  );
}

export const getExt = (url: string): any => {
  if (url.includes('?')) {
    return getExt(url.split('?')[0]);
  }

  if (url.includes('#')) {
    return getExt(url.split('#')[0]);
  }

  return url
    .trim()
    .toLowerCase()
    .split('.')
    .pop();
};

export function sleep(ms = 0) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function secondToTime(seconds = 0) {
  return DT.d2t(seconds.toFixed(3));
}

export const timeToSecond = (time: any): any => {
  return DT.t2d(time);
};

interface IDownloadProps {
  url: string;
  name: string;
  fromAPI?: boolean;
}

export const downloadFile = async ({
  url,
  name,
  fromAPI = false,
}: IDownloadProps): Promise<void> => {
  try {
    const response = fromAPI
      ? // Download autenticado
        await api.get(url, {
          headers: { 'Content-Type': 'application/octet-stream' },
          responseType: 'blob',
          timeout: 60000,
        })
      : // Download externo (signed)
        await axios.get(url, {
          headers: { 'Content-Type': 'application/octet-stream' },
          responseType: 'blob',
        });

    const elink = document.createElement('a');
    const virtualUrl = window.URL.createObjectURL(response.data);
    elink.href = virtualUrl;
    elink.download = name;
    elink.click();
  } catch (error) {
    return error as any;
  }
};

type INotifyType = 'success' | 'info' | 'warn' | 'error';

export const notify = (text = '', type: INotifyType = 'info') => {
  // info success warning error default
  return (
    text.trim() &&
    toast[type](text, {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    })
  );
};

export const getKeyCode = (event: any) => {
  const tag = document.activeElement
    ? document.activeElement.tagName.toUpperCase()
    : null;
  const editable = document.activeElement
    ? document.activeElement.getAttribute('contenteditable')
    : null;
  if (
    tag !== 'INPUT' &&
    tag !== 'TEXTAREA' &&
    editable !== '' &&
    editable !== 'true'
  ) {
    return Number(event.keyCode);
  }
};
